export default __webpack_public_path__ + "static/media/no_image_pet.85b709ee.jpeg";